var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"dashboard-sq-banner-auto justify-content-center text-center",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"d-flex flex-column"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }